/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Ledger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import New from './New/index'
import No from './No/index'
import Old from './Old/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Ledger({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let constantData = fromHelpers.getView('true')
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: constantData,
})
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.patient_id"
 patientId={tabPatientIdValueData}
 patientTab="ledger"
/>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Old'}>
<Old
  viewPath={`${viewPath}/Old`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'New'}>
<New
  viewPath={`${viewPath}/New`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}